import { randomId } from '@/library/message/lib';

import type * as Types from './PleasedChat.types';
export function createChatMessage(
  message: Partial<Types.ChatMessage> & Pick<Types.ChatMessage, 'authorType' | 'authorName' | 'authorId'>
): Types.ChatMessage {
  return {
    id: `${randomId()}-messageId`,
    type: message.attachment ? 'message.file' : 'message.text',
    message: '',
    timestamp: Date.now(),
    userSelection: false,
    ...message,
  };
}
export function createAttachment(attachment: {
  [K in keyof Types.ChatMessageAttachment]?: Types.ChatMessageAttachment[K] | null;
}): Types.ChatMessageAttachment | undefined {
  if (!attachment) return;
  const { id, contentType, url, name } = attachment || {};
  if (id && url && name) return { id, contentType: contentType || '', url, name };
}
